import { JcCommonProps, JcUtils } from 'jcsdk';
import { JcFadeIn } from '../../components/JcFadeIn';
import React from 'react';


interface JcCardProps extends JcCommonProps {
    title: string;
    children: React.ReactNode;
    onClick?: () => void;
    tags?: string[];
}

export const JcCard = (props: JcCardProps): React.ReactElement => {
    const commonProps = JcUtils.commonProps(props, ["jc-card", "jc-gradient", props.onClick && "jc-clickable"]);
    return <JcFadeIn {...commonProps} onClick={props.onClick}>
        <h3>{props.title}</h3>
        {props.children}
        <div className="tags">
            {props.tags?.map((tag) => <div className="tag" key={tag}>{tag}</div>)}
        </div>
    </JcFadeIn>;
}
